export default __webpack_public_path__ + "static/media/2a.93f22475.png";